export default __webpack_public_path__ + "locales/lv/Payments.json?hash=c29c39429209b5dc55fcdda83bab3432";